import http from '@/utils/http'


/**
 * 智能开关列表
*/
export function getSmartSocketList(data) {
    return http({
        method: 'post',
        url: '/smartSocket/paging',
        data
    })
}


/**
 * 获取子食堂列表
*/
export function getEntityList(params) {
    return http({
        method: 'get',
        url: '/system/xcwsSubEntity/available/list',
        params
    })
}

/**
 * 添加开关
*/
export function getSmartSocketAdd(data) {
    return http({
        method: 'post',
        url: '/smartSocket/add',
        data
    })
}

/**
 * 编辑开关
*/
export function getSmartSocketUpdate(data) {
    return http({
        method: 'post',
        url: '/smartSocket/update',
        data
    })
}

/**
 * 删除开关
*/
export function getSmartSocketDelete(params) {
    return http({
        method: 'post',
        url: '/smartSocket/delete',
        params
    })
}

/**
 * 禁用开关
*/
export function getSmartSocketDisable(params) {
    return http({
        method: 'post',
        url: '/smartSocket/disable',
        params
    })
}

/**
 * 启用开关
*/
export function getSmartSocketEnable(params) {
    return http({
        method: 'post',
        url: '/smartSocket/enable',
        params
    })
}